import type { Socket } from "socket.io-client";
import { io } from "socket.io-client";
import type { DefaultEventsMap } from "socket.io/dist/typed-events";

const uri =
  import.meta.env.VITE_MESSENGER_API_ORIGIN ??
  (typeof window !== "undefined" ? window.location.origin : "");

export const socket: Socket<DefaultEventsMap, DefaultEventsMap> = io(uri, {
  path: `${import.meta.env.VITE_MESSENGER_API_PATH ?? ""}/socket.io`,
  // Prevent polling as that cannot recover properly
  transports: ["websocket"],
  autoConnect: false,
});
